const TRANSLATIONS_EN = {
    batteryNameDuplicateError: 'A battery with this name already exists.',
    connectionError: 'Connection error. Click to retry.',
    saveFailed: 'Save failed. Click to retry.'
};

export default TRANSLATIONS_EN;
